import {config} from "../utils2/config";

export function useApp() {

    const name = config.get_app_name();
    const version = config.get_app_version_string();
    const isDebug = config.is_debug_mode();

    return {name, version, isDebug};
}